import { Fragment } from "react";
import Breadcrumb from "./common/breadcrumb";
import { Users, Home, User } from "react-feather";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarController,
  BarElement,
  ArcElement,
  Filler,
  RadialLinearScale,
} from "chart.js";

// image impoer
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Media,
  Row,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { FileCopySharp } from "@mui/icons-material";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarController,
  BarElement,
  ArcElement,
  Filler,
  RadialLinearScale,
);

const useStyles = makeStyles((theme) => ({
  dashMainCol: {
    display: "flex",
    justifyContent: "center",
  },

  dashMainMedia: {
    display: "flex",
    alignItems: "center !important",
  },

  dashMainDiv: {
    display: "grid",
    placeItems: "center",
  },

  dashIconDiv: {
    background: "aliceblue !important",
    marginBottom: "10px",
    width: "70px !important",
    height: "70px !important",
  },

  dashIcon: {
    width: "30px !important",
    height: "30px !important",
    color: "rgb(239, 65, 35)",
  },

  textBoldTitle: {
    fontWeight: "bold",
    fontSize: "18px",
    width: "220px !important",
  },
  textBold: {
    fontWeight: "bold",
    fontSize: "18px",
  },
  customerInfoCard: {
    marginTop: theme.spacing(12),
    borderRadius: 16,
    backgroundColor: "#ffffff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
  },

  customerName: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#2c2c2c",
  },

  customerRegion: {
    fontSize: "14px",
    color: "#6b7280",
    display: "flex",
    alignItems: "center",
  },

  locationIcon: {
    fontSize: "18px",
    marginRight: 6,
    color: "#EF4123",
  },

  paymentBadge: {
    display: "inline-block",
    padding: "6px 14px",
    fontSize: "13px",
    fontWeight: 500,
    borderRadius: 20,
    color: "#EF4123",
    backgroundColor: "#fff1ee",
    border: "1px solid #ffd6cc",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
}));

const DashboardAP = ({ onlyVendorRegistration = false }) => {
  const history = useNavigate();
  const classes = useStyles();
  const isAdminUser =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 1;

  const isVendorUser =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 0;

  const hasVendorCode =
    isVendorUser &&
    JSON.parse(sessionStorage.getItem("userData"))?.hasVendorCode === "Y";

  const isModenikUsers =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 16 ||
    JSON.parse(sessionStorage.getItem("userData")).groupId === 17 ||
    JSON.parse(sessionStorage.getItem("userData")).groupId === 18 ||
    JSON.parse(sessionStorage.getItem("userData")).groupId === 19 ||
    JSON.parse(sessionStorage.getItem("userData")).groupId === 20;

  const isSAPAdmin =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 21;

  if (isSAPAdmin) {
    return (
      <Fragment>
        <Container fluid={true}>
          <Row>
            <Breadcrumb title="Master" parent="" />
            <Card className=" o-hidden widget-cards">
              <CardBody style={{ display: "flex", overflow: "scroll" }}>
                <Col
                  onClick={() =>
                    history(
                      `${process.env.PUBLIC_URL}/master/vendorRegistrationList`,
                    )
                  }
                  xl="2"
                  md="2"
                  sm="2"
                  className={classes.dashMainCol}
                >
                  <Media
                    className={`static-top-widget ${classes.dashMainMedia}`}
                  >
                    <div
                      className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                    >
                      <div
                        className={`align-self-center text-center ${classes.dashIconDiv}`}
                      >
                        <Home className={classes.dashIcon} />
                      </div>

                      <h4 className="mb-0">
                        <small>Vendor Registration</small>
                      </h4>
                    </div>
                  </Media>
                </Col>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          {(isAdminUser || isModenikUsers) && (
            <>
              <Breadcrumb title="Master" parent="" />
              <Card className=" o-hidden widget-cards">
                <CardBody style={{ display: "flex", overflow: "scroll" }}>
                  <Col
                    onClick={() =>
                      history(`${process.env.PUBLIC_URL}/master/vendorType`)
                    }
                    xl="2"
                    md="2"
                    sm="2"
                    className={classes.dashMainCol}
                  >
                    <Media
                      className={`static-top-widget ${classes.dashMainMedia}`}
                    >
                      <div
                        className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                      >
                        <div
                          className={`align-self-center text-center ${classes.dashIconDiv}`}
                        >
                          <Home className={classes.dashIcon} />
                        </div>

                        <h4 className="mb-0">
                          <small>Vendor Type</small>
                        </h4>
                      </div>
                    </Media>
                  </Col>
                  <Col
                    onClick={() =>
                      history(`${process.env.PUBLIC_URL}/master/documentType`)
                    }
                    xl="2"
                    md="2"
                    sm="2"
                    className={classes.dashMainCol}
                  >
                    <Media
                      className={`static-top-widget ${classes.dashMainMedia}`}
                    >
                      <div
                        className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                      >
                        <div
                          className={`align-self-center text-center ${classes.dashIconDiv}`}
                        >
                          <Home className={classes.dashIcon} />
                        </div>

                        <h4 className="mb-0">
                          <small>Document Type</small>
                        </h4>
                      </div>
                    </Media>
                  </Col>
                  <Col
                    onClick={() =>
                      history(`${process.env.PUBLIC_URL}/master/offsetGlType`)
                    }
                    xl="2"
                    md="2"
                    sm="2"
                    className={classes.dashMainCol}
                  >
                    <Media
                      className={`static-top-widget ${classes.dashMainMedia}`}
                    >
                      <div
                        className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                      >
                        <div
                          className={`align-self-center text-center ${classes.dashIconDiv}`}
                        >
                          <Home className={classes.dashIcon} />
                        </div>

                        <h4 className="mb-0">
                          <small>OffsetGl Type</small>
                        </h4>
                      </div>
                    </Media>
                  </Col>
                  <Col
                    onClick={() =>
                      history(`${process.env.PUBLIC_URL}/master/paymentTerms`)
                    }
                    xl="2"
                    md="2"
                    sm="2"
                    className={classes.dashMainCol}
                  >
                    <Media
                      className={`static-top-widget ${classes.dashMainMedia}`}
                    >
                      <div
                        className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                      >
                        <div
                          className={`align-self-center text-center ${classes.dashIconDiv}`}
                        >
                          <Home className={classes.dashIcon} />
                        </div>

                        <h4 className="mb-0">
                          <small>Payment Terms</small>
                        </h4>
                      </div>
                    </Media>
                  </Col>
                  {/* <Col
                    onClick={() =>
                      history(
                        `${process.env.PUBLIC_URL}/master/vendorEvaluationList`,
                      )
                    }
                    xl="2"
                    md="2"
                    sm="2"
                    className={classes.dashMainCol}
                  >
                    <Media
                      className={`static-top-widget ${classes.dashMainMedia}`}
                    >
                      <div
                        className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                      >
                        <div
                          className={`align-self-center text-center ${classes.dashIconDiv}`}
                        >
                          <Home className={classes.dashIcon} />
                        </div>

                        <h4 className="mb-0">
                          <small>Vendor Evaluation</small>
                        </h4>
                      </div>
                    </Media>
                  </Col> */}
                  <Col
                    onClick={() =>
                      history(
                        `${process.env.PUBLIC_URL}/master/vendorRegistrationList`,
                      )
                    }
                    xl="2"
                    md="2"
                    sm="2"
                    className={classes.dashMainCol}
                  >
                    <Media
                      className={`static-top-widget ${classes.dashMainMedia}`}
                    >
                      <div
                        className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                      >
                        <div
                          className={`align-self-center text-center ${classes.dashIconDiv}`}
                        >
                          <Home className={classes.dashIcon} />
                        </div>

                        <h4 className="mb-0">
                          <small>Vendor Registration</small>
                        </h4>
                      </div>
                    </Media>
                  </Col>

                  <Col
                    onClick={() =>
                      history(`${process.env.PUBLIC_URL}/master/bulk-invite`)
                    }
                    xl="2"
                    md="2"
                    sm="2"
                    className={classes.dashMainCol}
                  >
                    <Media
                      className={`static-top-widget ${classes.dashMainMedia}`}
                    >
                      <div
                        className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                      >
                        <div
                          className={`align-self-center text-center ${classes.dashIconDiv}`}
                        >
                          <Home className={classes.dashIcon} />
                        </div>

                        <h4 className="mb-0">
                          <small>Vendor Bulk Invite</small>
                        </h4>
                      </div>
                    </Media>
                  </Col>
                </CardBody>
              </Card>
            </>
          )}

          {(isAdminUser ||
            isModenikUsers ||
            (isVendorUser && hasVendorCode)) && (
            <>
              <Breadcrumb title="Account Statement" parent="" />
              <Card className=" o-hidden widget-cards">
                <CardBody>
                  <Row>
                    <Col
                      onClick={() =>
                        history(`${process.env.PUBLIC_URL}/reports/ap/ledger`)
                      }
                      xl="2"
                      md="2"
                      sm="2"
                      className={classes.dashMainCol}
                    >
                      <Media
                        className={`static-top-widget ${classes.dashMainMedia}`}
                      >
                        <div
                          className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                        >
                          <div
                            className={`align-self-center text-center ${classes.dashIconDiv}`}
                          >
                            <FileCopySharp className={classes.dashIcon} />
                          </div>

                          <h4 className="mb-0 ">
                            <small>Ledger</small>
                          </h4>
                        </div>
                      </Media>
                    </Col>
                    {(isAdminUser || isModenikUsers) && (
                      <Col
                        onClick={() =>
                          history(
                            `${process.env.PUBLIC_URL}/reports/ap/vendor-documents`,
                          )
                        }
                        xl="2"
                        md="2"
                        sm="2"
                        className={classes.dashMainCol}
                      >
                        <Media
                          className={`static-top-widget ${classes.dashMainMedia}`}
                        >
                          <div
                            className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                          >
                            <div
                              className={`align-self-center text-center ${classes.dashIconDiv}`}
                            >
                              <FileCopySharp className={classes.dashIcon} />
                            </div>

                            <h4 className="mb-0">
                              <small>Vendor Documents</small>
                            </h4>
                          </div>
                        </Media>
                      </Col>
                    )}
                  </Row>
                </CardBody>
              </Card>
            </>
          )}

          {isAdminUser && !isModenikUsers && !isVendorUser && (
            <>
              <Breadcrumb title="User Management" parent="" />
              <Card className=" o-hidden widget-cards">
                <CardBody style={{ display: "flex" }}>
                  <Col
                    onClick={() =>
                      history(`${process.env.PUBLIC_URL}/userManagement/users`)
                    }
                    xl="2"
                    md="2"
                    sm="2"
                    className={classes.dashMainCol}
                  >
                    <Media
                      className={`static-top-widget ${classes.dashMainMedia}`}
                    >
                      <div
                        className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                      >
                        <div
                          className={`align-self-center text-center ${classes.dashIconDiv}`}
                        >
                          <User className={classes.dashIcon} />
                        </div>

                        <h4 className="mb-0">
                          <small>User</small>
                        </h4>
                      </div>
                    </Media>
                  </Col>
                  {/* <Col
                    onClick={() =>
                      history(`${process.env.PUBLIC_URL}/userManagement/group`)
                    }
                    xl="2"
                    md="2"
                    sm="2"
                    className={classes.dashMainCol}
                  >
                    <Media
                      className={`static-top-widget ${classes.dashMainMedia}`}
                    >
                      <div
                        className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                      >
                        <div
                          className={`align-self-center text-center ${classes.dashIconDiv}`}
                        >
                          <Users className={classes.dashIcon} />
                        </div>

                        <h4 className="mb-0 ">
                          <small>Group</small>
                        </h4>
                      </div>
                    </Media>
                  </Col> */}

                  {/*  <Col
                    onClick={() =>
                      history(
                        `${process.env.PUBLIC_URL}/userManagement/userLog`,
                      )
                    }
                    xl="2"
                    md="2"
                    sm="2"
                    className={classes.dashMainCol}
                  >
                    <Media
                      className={`static-top-widget ${classes.dashMainMedia}`}
                    >
                      <div
                        className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                      >
                        <div
                          className={`align-self-center text-center ${classes.dashIconDiv}`}
                        >
                          <User className={classes.dashIcon} />
                        </div>

                        <h4 className="mb-0">
                          <small>User Logs</small>
                        </h4>
                      </div>
                    </Media>
                  </Col> */}
                  {/*  <Col
                    onClick={() =>
                      history(
                        `${process.env.PUBLIC_URL}/userManagement/autoImportLogs`,
                      )
                    }
                    xl="2"
                    md="2"
                    sm="2"
                    className={classes.dashMainCol}
                  >
                    <Media
                      className={`static-top-widget ${classes.dashMainMedia}`}
                    >
                      <div
                        className={`icons-widgets col-12 text-center ${classes.dashMainDiv}`}
                      >
                        <div
                          className={`align-self-center text-center ${classes.dashIconDiv}`}
                        >
                          <User className={classes.dashIcon} />
                        </div>

                        <h4 className="mb-0">
                          <small>Auto Import Logs</small>
                        </h4>
                      </div>
                    </Media>
                  </Col> */}
                </CardBody>
              </Card>
            </>
          )}
        </Row>
      </Container>
    </Fragment>
  );
};

// javascript:void(0)

export default DashboardAP;
